import { useContext } from "react"
import { Form, Button, InputNumber } from "antd"
import { useHistory } from "react-router-dom"
import { ArrowLeftOutlined } from "@ant-design/icons"
import axios from "axios"
import { UserContext } from "../Context/UserContext"
import { WalletContext } from "../Context/WalletContext"

const TopupWallet = () => {
    const history = useHistory()
    const [user] = useContext(UserContext)
    const [userWallet] = useContext(WalletContext)

    const HandleBack = () => {
        history.goBack()
    }

    const onFinish = (values) => {
        const saldo = values.balance+userWallet.balance
        axios.put("https://backend-sportyan.vercel.app/api/wallet", {balance: saldo}, {headers: {"Authorization" : "Bearer "+ user.token}})
            .then(()=>{
                history.push("/profile")
                window.location.reload()
            })
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };


    return(
        <>
            <Button type="danger" icon={<ArrowLeftOutlined />} size="large" style={{marginBottom: "40px"}} onClick={HandleBack}>
                Kembali
            </Button>
            <Form
                name="basic"
                labelCol={{
                    span: 4,
                }}
                wrapperCol={{
                    span: 16,
                }}
                initialValues={{
                    remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
                <Form.Item 
                    label="Masukkan Jumlah Uang"
                    name="balance"
                    rules={[
                        {
                            required: true,
                            message: 'Please input balance!',
                        },
                    ]}
                >
                    <InputNumber prefix="Rp" style={{width: '100%'}} />
                </Form.Item>

                <Form.Item
                    wrapperCol={{
                    offset: 4,
                    span: 16,
                    }}
                >
                    <Button type="primary" htmlType="submit">
                    Submit
                    </Button>
                </Form.Item>
            </Form>

        </>
    )
}
export default TopupWallet